"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { APIDataSource } from "@/components/grid/data-source";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { Component, Ref, Mixins } from "vue-property-decorator";
import DateFormat from "@/framework/timeformatter";
import API from "@ym-framework/api-utils";
import { WebsocketViewService } from "@/utils/webSocketViewService";
const _gridController = new GridController(new APIDataSource(`api://base.auth/api/v8/message_center/all`));
import BlockDialog from "@/components/layout/components/dialog/BlockDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
let MessageMain = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.webSocketService = WebsocketViewService;
    this.selectItem = "unread";
    this.options = [
      {
        value: "all",
        label: this.$t("message_main.options_all")
      },
      {
        value: "unread",
        label: this.$t("message_main.options_unread")
      },
      {
        value: "read",
        label: this.$t("message_main.options_read")
      }
    ];
    this.gridController = _gridController;
  }
  mounted() {
    return __async(this, null, function* () {
      this.webSocketService._ipcEvent.on(
        "event:pageEvent.logout.refresh",
        (data) => __async(this, null, function* () {
          location.reload();
        })
      );
      this.gridController.query.params = {
        "is_new": true
      };
      this.gridController.pagePosition = "dialog";
      this.gridController.query.sort = "createdTime,desc";
      this.gridController.query.current = 1;
      yield this.gridController.search();
      if (this.gridController.result.datas.length === 0) {
        yield this.sendClearMark();
      }
    });
  }
  sendClearMark() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/websockets/main`, {
          model: "message.clear_mark",
          value: {
            message: "clear"
          }
        });
      } catch (error) {
      }
    });
  }
  openNotice() {
    return __async(this, null, function* () {
      var _a;
      if ((_a = this.$session) == null ? void 0 : _a.marks.is("KV_INTERNAL_USER")) {
      } else {
        this._block_dialog.open();
      }
    });
  }
  format_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatter(DateFormat.check(time));
    }
  }
  searchSelect(item) {
    return __async(this, null, function* () {
      if (this.selectItem === "unread") {
        this.gridController.query.params = {
          "is_new": true
        };
      }
      if (this.selectItem === "read") {
        this.gridController.query.params = {
          "is_new": false
        };
      }
      if (this.selectItem === "all") {
        this.gridController.query.params = null;
      }
      yield this.refresh();
    });
  }
  allRead() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v8/message_center/change_reads`);
      } catch (error) {
      } finally {
        yield this.refresh();
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.current = 1;
      yield this.gridController.search();
      if (this.gridController.result.datas.length === 0) {
        yield this.sendClearMark();
      }
    });
  }
  selectItems() {
  }
  checkDetails(data) {
    return __async(this, null, function* () {
      let arr = [];
      arr.push(data.guid);
      try {
        yield API.put(`api://base.auth/api/v8/message_center/change_read`, {
          "ids": arr
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.$router.push({ "path": "/message_detail", "query": { "guid": data.guid } });
      }
    });
  }
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
  }
};
__decorateClass([
  Ref("blockDialog")
], MessageMain.prototype, "_block_dialog", 2);
MessageMain = __decorateClass([
  Component({
    components: {
      UiGrid,
      BlockDialog
    }
  })
], MessageMain);
export {
  MessageMain as default
};
